module.exports = __webpack_public_path__ + "static/img/US.2589c6dd.jpg";